import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestDetailEvaluator } from '../shared/request-detail-evaluator.model';
import { RequestReponse } from '../../requets/shared/model/request-reponse.model';
import { ProgramService } from '../../programs/shared/program.service';
import { ParametersProgram } from '../../programs/shared/parameters-program.model';
import { Score } from '../../programs/shared/score.model';
import { Location } from '@angular/common';
import { SubjectEvaluateSelectedComponent } from '../subject-evaluate-selected/subject-evaluate-selected.component';
import { SubjectSelected } from '../shared/subject-selected.model';
import { RequestService } from '../../requets/shared/request.service';
import { StatusRequest } from '../../requets/shared/model/status-request.model';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { StatusDialogComponent } from '../../requets/status-dialog/status-dialog.component';

@Component({
  selector: 'app-evaluate-request',
  templateUrl: './evaluate-request.component.html',
  styleUrls: ['./evaluate-request.component.scss']
})
export class EvaluateRequestComponent implements OnInit {

  request: RequestReponse;
  requestDetail: RequestDetailEvaluator[];
  enabledSpinner = false;
  parameters: ParametersProgram;
  messageError = '';
  isCualitative = true;
  nota: number = 0;
  credito: number = 0;

  @ViewChild(SubjectEvaluateSelectedComponent) subjectEvaluateSelectedComponent: SubjectEvaluateSelectedComponent;


  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location,
              private dialog: MatDialog,
              private requestService: RequestService,
              private programService: ProgramService) {
    this.route.queryParams.subscribe(
      (params) => {
        const param = JSON.parse(params['param']);
        this.request = param.request;
        this.requestDetail = param.subjects;
        if (this.requestDetail.length > 1) {
          this.requestDetail.map(
            (subject: RequestDetailEvaluator) => {
              if (!subject.materia.cualitativa) {
                if (subject.numeroCreditos !== 0) {
                this.isCualitative = false;
                this.credito = this.credito + subject.numeroCreditos;
                this.nota = this.nota + (Number(subject.nota)) * subject.numeroCreditos;
                } else {
                  this.isCualitative = false;
                  this.credito = this.credito + subject.numeroCreditos;
                  this.nota = this.nota + (Number(subject.nota));
                }
              }
              this.getMinScore();
            }
          );
        } else {
          this.requestDetail.map(
            (subject: RequestDetailEvaluator) => {
              if (!subject.materia.cualitativa) {
                if (subject.numeroCreditos !== 0) {
                  this.isCualitative = false;
                  this.credito = this.credito + subject.numeroCreditos;
                  this.nota = this.nota + (Number(subject.nota)) * subject.numeroCreditos;
                } else {
                  this.isCualitative = false;
                  this.credito = this.credito + subject.numeroCreditos;
                  this.nota = this.nota + (Number(subject.nota));
                }
              }
              this.getMinScore();
            }
          );
        }
        if (this.credito !== 0) {
          this.nota = this.nota / this.credito;
        } else {
          this.nota = this.nota / this.requestDetail.length;
        }

      }
    );
  }

  ngOnInit() {
  }

  sendEvaluation() {
    let validate = true;
    this.messageError = '';
    this.subjectEvaluateSelectedComponent.subjects.map(
      (subject: SubjectSelected) => {
        if (!subject.periodo) {
            this.messageError = 'La materia: ' + subject.nombre + ' , debe tener periodo seleccionado';
            validate = false;
        }
        if (!subject.nota) {
            this.messageError = 'La materia: ' + subject.nombre + ', debe tener nota asignada';
            validate = false;
        }
        if (!subject.creditos) {
            this.messageError = 'La materia: ' + subject.nombre + ', debe tener creditos digitados';
            validate = false;
        }
        if (subject.comentario) {
            if (subject.comentario.trim().length > 250 ) {
                this.messageError = 'El comentario de la  materia: ' + subject.nombre + ', no debe sobre pasar los 250 caracteres';
                validate = false;
            }
        }
      }
    );

    if (validate) {
      const param = {
        request : this.request,
        subjects : this.requestDetail,
        subjectSelected: this.subjectEvaluateSelectedComponent.subjects.map(
          (subject: SubjectSelected) => {
            if (subject.cualitativa) {
              subject.nota = subject.nota === 'Aprobado' ? '7.7' : '8.8';
            }
            return subject;
          }
        )
      };
      this.router.navigate(['evaluaciones/evaluar/materias/confirmacion'], {queryParams : {param : JSON.stringify(param)}});
    }
  }

  close() {
    this.location.back();
  }
  showRequest() {
    this.enabledSpinner = true;
    this.requestService.getStatusRequest(this.request.solicitud.cedula).subscribe(
      (result) => {
        this.enabledSpinner = false;
        if (result.data) {
            const requestStatus = result.data as StatusRequest[];
            this.openDialogRequest(requestStatus);

        }
      }
    );
  }

  validateSeletion() {
    if (this.subjectEvaluateSelectedComponent) {
      if (this.subjectEvaluateSelectedComponent.subjects.length > 0) {
        return false;
      }
    }
    return true;
  }
  private getMinScore () {
    this.programService.getParamsProgram(this.request.programa.codigo).subscribe(
      (result) => {
        if (result.data) {
            this.parameters = result.data as ParametersProgram;
        }
      }
    );
  }

  private openDialogRequest(request: StatusRequest[]) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { request: request , cedula: this.request.solicitud.cedula , nombre : this.request.nombreEstudiante,
      programa: this.request.programa.nombre};
    dialogConfig.width = '80%';
    this.dialog.open(StatusDialogComponent, dialogConfig);
  }


}
